import MobileContacts from '@/components/MobileContacts';
const Contacts = () => {
  return <MobileContacts />;
};
export default Contacts;
